import { createRouter, createWebHistory } from 'vue-router'
import BodyView from "@/layout/BodyView.vue"
import authView from "@/layout/authView.vue"
import indexDashbord from "@/pages/indexDashbord.vue"
import loginPage from "@/pages/auth/loginPage.vue"
import ConductoresTablePage from "@/pages/conductores/ConductoresTablePage.vue"
import SolicitudesPage from "@/pages/nuevos-conductores/SolicitudesPage.vue"
import PlaceholderPage from "@/pages/PlaceholderPage.vue"
import SoporteAppTicketsPage from "@/pages/soporte/SoporteAppTicketsPage.vue"
import TarifasPage from "@/pages/configuracion/TarifasPage.vue"
import PeajesPage from "@/pages/configuracion/PeajesPage.vue"
import ZonasPage from "@/pages/configuracion/ZonasPage.vue"
import ZonaFormPage from "@/pages/configuracion/ZonaFormPage.vue"
import CuponesPage from "@/pages/bonificaciones/CuponesPage.vue"
import CuponesFormPage from "@/pages/bonificaciones/CuponesFormPage.vue"
import BonoConductorPage from "@/pages/bonificaciones/BonoConductorPage.vue"
import BonoConductorFormPage from "@/pages/bonificaciones/BonoConductorFormPage.vue"
import AltaUsuariosPage from "@/pages/gestion-usuarios/AltaUsuariosPage.vue"
import ConsultaUsuariosPage from "@/pages/gestion-usuarios/ConsultaUsuariosPage.vue"
import LegalDocumentPage from "@/pages/legal/LegalDocumentPage.vue"
import { isAuthenticated } from '@/services/session'

const routes = [
  {
    path: '/auth',
    component: authView,
    children: [
      {
        path: 'login',
        name: 'login',
        component: loginPage,
        meta: { title: 'Iniciar sesión - Dashboard Admin', public: true }
      },
      {
        path: '/legal/terminos',
        name: 'legal-terminos',
        component: LegalDocumentPage,
        props: { documentType: 'terminos' },
        meta: { title: 'Términos y Condiciones - Tec Driver', public: true, allowWhenAuthenticated: true }
      },
      {
        path: '/legal/privacidad',
        name: 'legal-privacidad',
        component: LegalDocumentPage,
        props: { documentType: 'privacidad' },
        meta: { title: 'Política de Privacidad - Tec Driver', public: true, allowWhenAuthenticated: true }
      }
    ]
  },
  {
    path: '/',
    component: BodyView,
    meta: { requiresAuth: true },
    children: [
      { path: '/', name: 'dashbord', component: indexDashbord, meta: { title: 'Dashboard Admin' } },
      // Conductores (Nest) — estilo TOPIX: meta.conductoresTipo
      {
        path: '/conductores/solicitudes',
        name: 'conductores-solicitudes',
        component: SolicitudesPage,
        meta: { title: 'Solicitudes', breadcrumbMain: 'Conductores', conductoresTipo: 'solicitudes' },
      },
      {
        path: '/conductores/activos',
        name: 'conductores-activos',
        component: ConductoresTablePage,
        meta: { title: 'Conductores activos', breadcrumbMain: 'Conductores', conductoresTipo: 'activos' },
      },
      {
        path: '/conductores/inactivos',
        name: 'conductores-inactivos',
        component: ConductoresTablePage,
        meta: { title: 'Conductores inactivos', breadcrumbMain: 'Conductores', conductoresTipo: 'inactivos' },
      },
      {
        path: '/conductores/en-viaje',
        name: 'conductores-en-viaje',
        component: ConductoresTablePage,
        meta: { title: 'Conductores en viaje', breadcrumbMain: 'Conductores', conductoresTipo: 'en-viaje' },
      },
      {
        path: '/conductores/calificando',
        name: 'conductores-calificando',
        component: ConductoresTablePage,
        meta: { title: 'Conductores calificando', breadcrumbMain: 'Conductores', conductoresTipo: 'calificando' },
      },
      // Redirects rutas legacy
      { path: '/nuevos-conductores/solicitudes', redirect: '/conductores/solicitudes' },
      { path: '/conductores/aprobados', redirect: '/conductores/activos' },
      { path: '/conductores/conectados', redirect: '/conductores/activos' },
      { path: '/conductores/desconectados', redirect: '/conductores/inactivos' },
      { path: '/conductores/vencidos', redirect: '/conductores/inactivos' },
      { path: '/conductores/calificacion-pendiente', redirect: '/conductores/calificando' },
      // Configuración
      {
        path: '/tarifas',
        name: 'tarifas',
        component: TarifasPage,
        meta: { title: 'Tarifas', breadcrumbMain: 'Configuración' },
      },
      {
        path: '/administracion-zonas',
        name: 'zonas',
        component: ZonasPage,
        meta: { title: 'Zonas', breadcrumbMain: 'Configuración' },
      },
      {
        path: '/administracion-zonas/nueva',
        name: 'zona-nueva',
        component: ZonaFormPage,
        meta: { title: 'Agregar zona', breadcrumbMain: 'Configuración' },
      },
      {
        path: '/administracion-zonas/:id',
        name: 'zona-editar',
        component: ZonaFormPage,
        meta: { title: 'Editar zona', breadcrumbMain: 'Configuración' },
      },
      {
        path: '/peajes',
        name: 'peajes',
        component: PeajesPage,
        meta: { title: 'Peajes', breadcrumbMain: 'Configuración' },
      },
      { path: '/pagos', component: PlaceholderPage, props: { title: 'Pagos' }, meta: { title: 'Pagos', breadcrumbMain: 'Finanzas' } },
      {
        path: '/cupones',
        name: 'cupones',
        component: CuponesPage,
        meta: { title: 'Cupones', breadcrumbMain: 'Bonificaciones' },
      },
      {
        path: '/cupones/alta',
        name: 'cupones-alta',
        component: CuponesFormPage,
        meta: { title: 'Alta de cupón', breadcrumbMain: 'Bonificaciones' },
      },
      {
        path: '/cupones/:id',
        name: 'cupones-editar',
        component: CuponesFormPage,
        meta: { title: 'Editar cupón', breadcrumbMain: 'Bonificaciones' },
      },
      {
        path: '/bono-conductor',
        name: 'bono-conductor',
        component: BonoConductorPage,
        meta: { title: 'Bono conductor', breadcrumbMain: 'Bonificaciones' },
      },
      {
        path: '/bono-conductor/nuevo',
        name: 'bono-conductor-nuevo',
        component: BonoConductorFormPage,
        meta: { title: 'Nueva bonificación', breadcrumbMain: 'Bonificaciones' },
      },
      {
        path: '/bono-conductor/:id',
        name: 'bono-conductor-editar',
        component: BonoConductorFormPage,
        meta: { title: 'Editar bonificación', breadcrumbMain: 'Bonificaciones' },
      },
      { path: '/historial-viajes', component: PlaceholderPage, props: { title: 'Historial de viajes' }, meta: { title: 'Historial de viajes' } },
      {
        path: '/centro-atencion/conductores',
        component: SoporteAppTicketsPage,
        meta: {
          title: 'Soporte conductores',
          breadcrumbMain: 'Centro de atención',
          supportAuthorType: 'DRIVER',
          sectionTitle: 'Tickets conductores',
        },
      },
      {
        path: '/centro-atencion/clientes',
        component: SoporteAppTicketsPage,
        meta: {
          title: 'Soporte clientes',
          breadcrumbMain: 'Centro de atención',
          supportAuthorType: 'CLIENT',
          sectionTitle: 'Tickets clientes',
        },
      },
      { path: '/ahorros', component: PlaceholderPage, props: { title: 'Ahorros' }, meta: { title: 'Ahorros', breadcrumbMain: 'Finanzas' } },
      { path: '/gestion-usuarios/alta', name: 'alta-usuarios', component: AltaUsuariosPage, meta: { title: 'Alta de usuarios', breadcrumbMain: 'Gestión de usuarios' } },
      { path: '/gestion-usuarios/consulta', name: 'consulta-usuarios', component: ConsultaUsuariosPage, meta: { title: 'Consulta de usuarios', breadcrumbMain: 'Gestión de usuarios' } }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  if (typeof to.meta.title === 'string') {
    document.title = to.meta.title
  }
  const isPublic = to.meta.public
  const authed = isAuthenticated()
  if (isPublic && authed && !to.meta.allowWhenAuthenticated) {
    return next('/')
  }
  if (!isPublic && !authed) {
    return next('/auth/login')
  }
  next()
})

export default router
